module.exports = {"id":"s2-q2a","text":"Did you access the training on your own device or was one provided for you?","multiselect":false,"options":[{"id":"s2-q2a-a1","text":"My own device","next":"s2-q2b","capability":2,"access":2},{"id":"s2-q2a-a2","text":"Provided device","next":"s2-q2b","capability":1,"access":-1}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q2a.json
// module id = 908
// module chunks = 32